import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API Service for Roll Up Lumpia Co.
class ApiService {
  constructor() {
    this.client = axios.create({
      baseURL: API,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  // Contact Form API
  async submitContactForm(formData) {
    try {
      const response = await this.client.post('/contact', formData);
      return response.data;
    } catch (error) {
      console.error('Contact form submission error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to send message');
    }
  }

  // Events API
  async getEvents(status = null) {
    try {
      const params = status ? { status_filter: status } : {};
      const response = await this.client.get('/events', { params });
      return response.data;
    } catch (error) {
      console.error('Get events error:', error);
      throw new Error('Failed to load events');
    }
  }

  // Admin API
  async adminLogin(password) {
    try {
      const response = await this.client.post('/admin/login', { password });
      return response.data;
    } catch (error) {
      console.error('Admin login error:', error);
      throw new Error(error.response?.data?.detail || 'Login failed');
    }
  }

  // Protected Admin API (requires token)
  setAuthToken(token) {
    if (token) {
      this.client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  async createEvent(eventData, token) {
    this.setAuthToken(token);
    try {
      const response = await this.client.post('/admin/events', eventData);
      return response.data;
    } catch (error) {
      console.error('Create event error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to create event');
    }
  }

  async updateEvent(eventId, eventData, token) {
    this.setAuthToken(token);
    try {
      const response = await this.client.put(`/admin/events/${eventId}`, eventData);
      return response.data;
    } catch (error) {
      console.error('Update event error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to update event');
    }
  }

  async deleteEvent(eventId, token) {
    this.setAuthToken(token);
    try {
      const response = await this.client.delete(`/admin/events/${eventId}`);
      return response.data;
    } catch (error) {
      console.error('Delete event error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to delete event');
    }
  }

  async getContactSubmissions(token) {
    this.setAuthToken(token);
    try {
      const response = await this.client.get('/admin/contacts');
      return response.data;
    } catch (error) {
      console.error('Get contact submissions error:', error);
      throw new Error('Failed to load contact submissions');
    }
  }
}

// Create and export a single instance
const apiService = new ApiService();
export default apiService;